<template>
  <FormElement
    type="hidden"
    gk-select
    :class="$style.select"
    :color="color"
    :size="size"
    :group="group"
    :field="field"
    :validity="validity"
    :rule="rule"
    :trigger="trigger"
    :customRule="customRule"
    :delay="delay"
    :readonly="readonly"
    :disabled="disabled"
    :focused="visible"
    :tips="tips"
    :gkselect-color="color"
    :gkselect-size="size"
    v-model="currentValue"
    @mouseenter.native="hover = true"
    @mouseleave.native="hover = false"
  >
    <template slot="validity">
      <input type="hidden" />
    </template>

    <template slot="pre"><slot name="pre" :focused="visible" /></template>

    <div :class="$style['select-label']" gk-select-label :placeholder="!currentOptions.length" @click="handleShowOptions">
      <slot name="label" :label="currentLabel">
        <gkFormText
          gk-select-text
          :class="$style['select-text']"
          :field="`__${field}-text`"
          :delay="300"
          :placeholder="placeholder"
          v-model="inputValue"
          @input="handleInput"
          v-if="input"
        />
        <template v-else>
          {{currentLabel}}
        </template>
      </slot>
    </div>

    <transition :name="popupTransition" @before-leave="onBeforeLeave">
      <slot name="options" v-if="visible">
        <div :class="$style['select-popup']" :style="positionStyle" gk-select-popup>
          <gkScrollbar gkselect-scrollbar>
            <slot name="popup" :choose="handleChooseOption" :close="handleHideOptions" :options="formatOptions">
              <div :class="$style['select-options']" gk-select-options>
                <template v-for="option in formatOptions">
                  <div :class="$style['select-option']" gk-select-option :selected="currentValue == option.value" @click="handleChooseOption(option)" :disabled="!!option.disabled" :key="option.value" v-if="!input">
                    <slot name="option" :option="option">{{option.label}}</slot>
                  </div>
                  <div :class="$style['select-option']" gk-select-option filter-option :selected="currentValue == option.value" @click="handleChooseOption(option)" :key="option.value" v-else v-html="option.label" />
                </template>
              </div>
            </slot>
          </gkScrollbar>
        </div>
      </slot>
    </transition>

    <template slot="tips" v-if="tips || $slots.tips">
      <slot name="tips" :tips="tips" :focused="visible">{{tips}}</slot>
    </template>

    <template slot="error" slot-scope="{message}">
      <slot name="error" :message="message" :focused="visible">{{message}}</slot>
    </template>

    <template slot="end"><slot name="end" :focused="visible" /></template>
  </FormElement>
</template>

<script>
import formProps from '../../components/form/form.props'
import validityProps from '../../components/form/validity.props'
import VueTypes from 'vue-types'

import FormElement from '../../components/form/FormElement'
import gkFormText from '../../components/form/FormText'
import gkScrollbar from '../../components/scrollbar/Scrollbar.vue'

export default {
  name: 'gkui-form-select-v2',
  components: {
    FormElement,
    gkFormText,
    gkScrollbar
  },
  props: Object.assign({}, formProps, validityProps, {
    /**
     * 激活验证的方式
     */
    trigger: VueTypes.array.def(['input']),
    transition: VueTypes.string.def(''),
    position: VueTypes.oneOf(['top', 'bottom', 'center', 'auto']).def('bottom'),
    side: VueTypes.oneOf(['left', 'right', 'auto']).def('left'),
    title: VueTypes.string.def(''),
    touch: VueTypes.bool.def(false),
    type: VueTypes.oneOf(['normal', 'filter', 'search', 'input']).def('normal'),
    placeholder: VueTypes.string.def('请选择...'),
    options: VueTypes.array.def([]),
    height: VueTypes.number.def(36),
    offset: VueTypes.number.def(0),
    formatLabel: VueTypes.func.def(options => options[0].label)
  }),
  data () {
    return {
      currentValue: this.value,
      inputValue: '',
      formatOptions: [],
      visible: false,
      hover: false,
      positionStyle: {}
    }
  },
  computed: {
    input () {
      return this.type === 'input' || this.type === 'filter' || this.type === 'search'
    },
    popupTransition () {
      return this.transition || `slide-${this.position}`
    },
    currentOptions () {
      const curOption = this.options.find(option => option.value === this.currentValue)
      const option = curOption ? [curOption] : []

      return option
    },
    currentLabel () {
      return this.currentOptions.length ? this.formatLabel(this.currentOptions) : this.placeholder
    }
  },
  watch: {
    value (value) {
      this.currentValue = value
      // this.init()
    },
    options (options) {
      this.parseOptions(options)
    },
    hover (val, old) {
      if (!val) {
        document.addEventListener('click', this.handleListenerShow)
      } else {
        document.removeEventListener('click', this.handleListenerShow)
      }
    }
  },
  created () {
    // this.init()
  },
  mounted () {
    this.parseOptions()
    this.initPositionStyle()
  },
  methods: {
    /**
     * 当选项收起时，过滤掉点击事件
     */
    onBeforeLeave (el) {
      el.style.pointerEvents = 'none'
    },
    parseOptions (options) {
      options = options || [].concat(this.options)

      this.formatOptions = options
    },
    filterOptions (value = '') {
      this.$emit('text', value)

      if (!value) {
        this.parseOptions()

        return
      }

      const reg = new RegExp(value)

      this.formatOptions = this.formatOptions.reduce((options, option) => {
        if (reg.test(option.label)) {
          options.push({
            value: option.value,
            label: option.label.replace(reg, `<span>${value}</span>`),
            disabled: option.disabled
          })
        }

        return options
      }, [])

      // this.formatOptions = this.formatOptions.filter(option => reg.test(option.label))
    },
    initPositionStyle () {
      const height = this.$el.offsetHeight
      const offset = height + this.offset
      const style = {}

      switch (this.side) {
        case 'left':
          style.left = 0
          style.right = 'auto'
          break
        case 'right':
          style.left = 'auto'
          style.right = 0
          break
        default:
          break
      }

      switch (this.position) {
        case 'top':
          style.top = 'auto'
          style.bottom = `${offset}px`
          break
        case 'bottom':
          style.top = `${offset}px`
          style.bottom = 'auto'
          break
        default:
          break
      }

      this.positionStyle = style
    },
    handleInput (value) {
      this.filterOptions(value)

      if (this.type === 'search' || this.type === 'input') {
        this.$emit('text', value)
      }
    },
    // init () {
    //   if (this.currentValue || typeof this.currentValue === 'number') {
    //     const curOption = this.options.find(option => option.value === this.currentValue)

    //     if (curOption) {
    //       this.currentOptions = [curOption]
    //     }
    //   }
    // },
    /**
     * 显示备选项
     */
    handleShowOptions () {
      if (this.disabled || this.readonly) {
        return
      }

      if (this.visible) {
        this.hover = false
        this.handleHideOptions()
      } else {
        this.visible = true
        this.$emit('focus')
      }
    },
    /**
     * 关闭备选项
     */
    handleHideOptions () {
      const option = this.currentOptions[0]

      if (this.type === 'filter' && option) {
        this.inputValue = option.label
        this.$emit('text', option.label)
      }

      this.visible = false
      this.$emit('blur')
    },
    /**
     * options 显示监听事件
     */
    handleListenerShow () {
      if (!this.hover) {
        this.handleHideOptions()

        document.removeEventListener('click', this.handleListenerShow)
      }
    },
    /**
     * 选择一个选项
     */
    handleChooseOption (option) {
      if (option.disabled) {
        return
      }

      // this.currentOptions = [option]
      this.currentValue = option.value
      this.handleHideOptions()

      if (this.type === 'search' || this.type === 'input') {
        this.inputValue = option.label
        this.$emit('text', option.label)
      }

      this.$emit('input', option.value)
      this.$emit('choose', this.currentOptions)
    }
  }
}
</script>

<style lang="scss" module>
.select {
  cursor: pointer;

  &[disabled] {
    cursor: not-allowed;
  }
}
.select-label {
  flex: 1;
  display: flex;
  align-items: center;
  line-height: 1;
  user-select: none;
}
.select-text {
  flex: 1;
}
.select-popup {
  overflow-y: auto;
  position: absolute; left: 0; z-index: 1;
  min-width: 100%;
  margin: 0 -1px;
}
.select-options {
  background: #FFF;
  user-select: none;
}
.select-option {
  display: flex;
  align-items: center;
  line-height: 1;
}
</style>

<style scoped>
/* position: bottom */
.slide-bottom-enter-active {
  transform-origin: top center;
  animation: pupup-slide-in-y 0.4s cubic-bezier(0.23, 1, 0.32, 1);
}
.slide-bottom-leave-active {
  transform-origin: top center;
  animation: popup-slide-out-y 0.6s cubic-bezier(0.23, 1, 0.32, 1);
}

/* position: top */
.slide-top-enter-active {
  transform-origin: bottom center;
  animation: pupup-slide-in-y 0.4s cubic-bezier(0.23, 1, 0.32, 1);
}
.slide-top-leave-active {
  transform-origin: bottom center;
  animation: popup-slide-out-y 0.6s cubic-bezier(0.23, 1, 0.32, 1);
}

/*  Y 轴滑动打开  */
@-webkit-keyframes pupup-slide-in-y {
  0% {
    opacity: 0;
    transform: scaleY(0.4)
  }

  100% {
    opacity: 1;
    transform: scaleY(1)
  }
}

@keyframes pupup-slide-in-y {
  0% {
    opacity: 0;
    transform: scaleY(0.4)
  }

  100% {
    opacity: 1;
    transform: scaleY(1)
  }
}

/*  Y 轴滑动收起  */
@-webkit-keyframes popup-slide-out-y {
  0% {
    opacity: 1;
    transform: scaleY(1)
  }

  100% {
    opacity: 0;
    transform: scaleY(0.4)
  }
}

@keyframes popup-slide-out-y {
  0% {
    opacity: 1;
    transform: scaleY(1)
  }

  100% {
    opacity: 0;
    transform: scaleY(0.4)
  }
}
</style>

